import ControlledSubstances from './ControlledSubstances';

export default ControlledSubstances;
